import { WebSocketService } from './services/web-socket.service';
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { TrendingResearchComponent } from "./components/trending-research/trending-research.component";
import { RolesSharedService } from "@app/feature/main/roles-shared/services/roles-shared.service";
import { ReportsComponent } from "./components/reports/reports.component";
import { ContactUsComponent } from "./components/contact-us/contact-us.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { FutureResearchComponent } from "./components/future-research/future-research.component";
import { AnalystListComponent } from "./components/analyst-list/analyst-list.component";
import { TechDomainsListComponent } from "./components/tech-domains-list/tech-domains-list.component";
import { Ng2TelInputModule } from "ng2-tel-input";
import { AppSharedModule } from "@app/shared/app-shared.module";
import { SocialFeedComponent } from "./components/social-feed/social-feed.component";
import { AllResearchComponent } from "./components/all-research/all-research.component";
import { BlogsComponent } from "./components/blogs/blogs.component";
import { UnderConstructionComponent } from "./components/under-construction/under-construction.component";
import { ChatBotIconComponent } from "@app/feature/main/roles-shared/chat-bot-icon/chat-bot-icon.component";
import { SupportComponent } from "./components/support/support.component";
import { CompanyDetailsComponent } from "../tech-buyer/company-details/company-details.component";
import { NguiAutoCompleteModule } from '@ngui/auto-complete';
import { NgxTypeaheadModule } from "ngx-typeahead";
import { httpInterceptorProviders } from "@shared/http-interceptors/index";
import { TechBuyerService } from "@app/feature/main/tech-buyer/shared/services/tech-buyer.service";
import { ResearchSnapshotComponent } from "./components/research-snapshot/research-snapshot.component";
import { ResearchDetailComponent } from "./components/research-detail/research-detail.component";
import { SurveyParserService } from "@app/feature/main/roles-shared/services/survey-view-parser.service";
import { ChartComponent } from "./components/chart/chart.component";
import { DataService } from "@app/feature/main/roles-shared/services/data.service";
import { MarketDataChartGeneratorService } from "@app/feature/main/roles-shared/services/market-data-chart-generator.service";
import { MarketDataDetailsComponent } from "./components/market-data-details/market-data-details.component";
import { MarketDataDetailsService } from "@app/feature/main/roles-shared/services/market-data-details.service";
import { MarketDataFilterComponent } from "./components/market-data-filter/market-data-filter.component";
import { ModalServiceService } from "@app/feature/main/roles-shared/services/modal-service.service";
import { BookmarkedItemListComponent } from "./components/bookmarked-item-list/bookmarked-item-list.component";

import { RatingComponent } from "./components/rating/rating.component";
import { ReportDetailsComponent } from "./components/report-details/report-details.component";
import { ConnectionsComponent } from "./components/connections/connections.component";

import { WebPushNotificationService } from "@app/feature/main/roles-shared/services/web-push-notification.service";
import { AllBookmarkListComponent } from "./components/all-bookmark-list/all-bookmark-list.component";
import { PushNotificationsComponent } from "./components/push-notifications/push-notifications.component";
import { MessagesListComponent } from "./components/messages-list/messages-list.component";
import { FollowedAnalystListComponent } from './components/followed-analyst-list/followed-analyst-list.component';
import { ImageCropperModule } from 'ngx-image-cropper';
import { ShareModule } from '@ngx-share/core';
import { PurchaseTokensComponent } from "@app/feature/main/roles-shared/components/purchase-tokens/purchase-tokens.component";
import { ConnectSnapshotComponent } from "@app/feature/main/roles-shared/components/connect-snapshot/connect-snapshot.component";
import { ModalModule } from "ngx-bootstrap";
import { NewUserConnectSnapshotComponent } from "@app/feature/main/roles-shared/components/new-user-connect-snapshot/new-user-connect-snapshot.component";
import { PrivacySettingsComponent } from "@app/feature/main/roles-shared/components/privacy-settings/privacy-settings.component";
import { ProfileMiniService } from "@app/feature/main/roles-shared/services/profile-mini.service";
import { CheckoutModalComponent } from "@app/feature/main/roles-shared/components/checkout-modal/checkout-modal.component";
import { NotificationService } from "@app/feature/main/roles-shared/services/notification.service";
import { RulesAndRegulationsComponent } from "@app/feature/main/roles-shared/components/rules-and-regulations/rules-and-regulations.component";
import { ContactUsService } from "@app/feature/main/roles-shared/services/contact-us.service";
import { BsDropdownModule } from 'ngx-bootstrap';
import {BreadcrumbModule} from 'primeng/breadcrumb';
import { BookMarkMarketDataResolverService } from "./services/book-mark-market-data-resolver.service";
import { SocialShare } from '@app/shared/services/social-share.service';
import { SSTService } from '@app/feature/main/roles-shared/services/self-service-tab.service';
import { SelfServiceTabComponent } from '@app/feature/main/roles-shared/components/self-service-tab/self-service-tab.component';
import { SSTGraphMethodsComponent } from './components/self-service-tab/components/sst-graph-methods/sst-graph-methods.component';
import { SSTGraphListComponent } from './components/self-service-tab/components/sst-graph-list/sst-graph-list.component';
import { SSTGraphChartComponent } from './components/self-service-tab/components/sst-graph-chart/sst-graph-chart.component';
import { SSTGraphAxisComponent } from './components/self-service-tab/components/sst-graph-axis/sst-graph-axis.component';
import { BubleChartColorSelectionService } from "@app/feature/main/roles-shared/services/buble-chart-color-selection.service";
import {TooltipModule} from 'primeng/tooltip';
import { BenchmarkPopoverComponent } from "./components/benchmark-popover/benchmark-popover.component";
import { CountdownModule } from 'ngx-countdown';
import { GlobalSearchPageComponent } from './global-search-page/global-search-page.component';
import { RouterModule, Routes } from '@angular/router';
import {MultiSelectModule} from 'primeng/multiselect';
import {ChipsModule} from 'primeng/chips';
import { IndividualMarketdataComponent } from './components/individual-marketdata/individual-marketdata.component';
import { PackageSubscriptionComponent } from './components/package-subscription/package-subscription.component';
import { PackageSubscriptionService } from './services/package-subscription.service';
import { PackageSubscriptionDetailsComponent } from './components/package-subscription-details/package-subscription-details.component';
import { GlobalDataSharedService } from './services/global-data-shared-service.service';
import { CustomDurationPipe } from './pipes/custom-duration.pipe';
import { CustomMessageTimeZonePipe } from './pipes/custom-message-time-zone.pipe';
import { MailtoPipe } from './pipes/mailto.pipe';
import { AnalystSearchComponent } from './components/analyst-search/analyst-search.component';
import { AnalystSearchFiltersComponent } from './components/analyst-search/analyst-search-filters/analyst-search-filters.component';
import { AnalystSearchResultsComponent } from './components/analyst-search/analyst-search-results/analyst-search-results.component';
import { AnalystComponent } from './components/analyst-search/analyst-search-results/analyst/analyst.component';
import { SelectAnalystComponent } from './components/analyst-search/select-analyst/select-analyst.component';
import { CheckboxModule } from 'primeng/checkbox';
import { ServiceProvidersService } from './services/service-providers.service';
import { ConfirmDialogComponent } from './layout/confirm-dialog/confirm-dialog.component';
import { DeleteModalComponent } from './layout/delete-modal/delete-modal.component';
import { GroupCallModalComponent } from './layout/group-call-modal/group-call-modal.component';
import { RatingAndReviewComponent } from './layout/rating-and-review/rating-and-review.component';
import { CommentMentionPipe } from './pipes/comment-mention.pipe';
import { CommentsPipe } from './pipes/comments.pipe';
import { LikesPipe } from './pipes/likes.pipe';
import { NameLetterPipe } from './pipes/name-letter.pipe';
import { RepliesPipe } from './pipes/replies.pipe';
import { SafeHtmlPipe } from './pipes/safe-html.pipe';
import { SortByPipe } from './pipes/sort.pipe';
import { GroupCallScheduleComponent } from './layout/group-call-schedule/group-call-schedule.component';
import { RatingAndReviewService } from './services/rating-and-review.service';

const routes: Routes = [
  {
    path: 'global-search',
    component: GlobalSearchPageComponent
  }
]

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    AppSharedModule,
    Ng2TelInputModule,
    NgxTypeaheadModule,
    NguiAutoCompleteModule,
    ImageCropperModule,
    ModalModule.forRoot(),
    BreadcrumbModule,
    TooltipModule,
    BsDropdownModule.forRoot(),
    CountdownModule,
    MultiSelectModule,
    RouterModule.forChild(routes),
    ChipsModule,
    CheckboxModule
  ],
  declarations: [
    TrendingResearchComponent,
    ReportsComponent,
    ContactUsComponent,
    FutureResearchComponent,
    AnalystListComponent,
    TechDomainsListComponent,
    SocialFeedComponent,
    AllResearchComponent,
    BlogsComponent,
    UnderConstructionComponent,
    SupportComponent,
    CompanyDetailsComponent,
    ResearchSnapshotComponent,
    ResearchDetailComponent,
    ChartComponent,
    MarketDataDetailsComponent,
    MarketDataFilterComponent,
    BookmarkedItemListComponent,
    RatingComponent,
    ReportDetailsComponent,
    ConnectionsComponent,
    AllBookmarkListComponent,
    PushNotificationsComponent,
    MessagesListComponent,
    FollowedAnalystListComponent,
    PurchaseTokensComponent,
    ConnectSnapshotComponent,
    NewUserConnectSnapshotComponent,
    PrivacySettingsComponent,
    CheckoutModalComponent,
    RulesAndRegulationsComponent,
    SelfServiceTabComponent,
    SSTGraphMethodsComponent,
    SSTGraphAxisComponent,
    SSTGraphListComponent,
    SSTGraphChartComponent,
    BenchmarkPopoverComponent,
    GlobalSearchPageComponent,
    IndividualMarketdataComponent,
    PackageSubscriptionComponent,
    PackageSubscriptionDetailsComponent,
    MailtoPipe,
    CustomDurationPipe,
    CustomMessageTimeZonePipe,
    AnalystSearchComponent,
    AnalystSearchResultsComponent,
    AnalystSearchFiltersComponent,  
    AnalystComponent,
    SelectAnalystComponent,
    ConfirmDialogComponent,
    DeleteModalComponent,
    GroupCallModalComponent,
    RatingAndReviewComponent,
    CommentMentionPipe,
    CommentsPipe,
    LikesPipe,
    NameLetterPipe,
    RepliesPipe,
    SafeHtmlPipe,
    SortByPipe,
    GroupCallScheduleComponent
    ],

  providers: [
    RolesSharedService,
    TechBuyerService,
    SurveyParserService,
    DataService,
    MarketDataChartGeneratorService,
    MarketDataDetailsService,
    ModalServiceService,
    WebPushNotificationService,
    ProfileMiniService,
    NotificationService,
    ContactUsService,
    BookMarkMarketDataResolverService,
    SocialShare,
    SSTService,
    BubleChartColorSelectionService,
    WebSocketService,
    PackageSubscriptionService,
    ServiceProvidersService,
    RatingAndReviewService
  ],
  exports: [
    NgxTypeaheadModule,
    Ng2TelInputModule,
    ChatBotIconComponent,
    CompanyDetailsComponent,
    MarketDataDetailsComponent,
    MarketDataFilterComponent,
    BookmarkedItemListComponent,
    ReportDetailsComponent,
    ChartComponent,
    ImageCropperModule,
    PurchaseTokensComponent,
    ConnectSnapshotComponent,
    NewUserConnectSnapshotComponent,
    PrivacySettingsComponent,
    CheckoutModalComponent,
    BenchmarkPopoverComponent,
    GlobalSearchPageComponent,
    RouterModule,
    BenchmarkPopoverComponent,
    ChipsModule,
    MailtoPipe,
    CustomDurationPipe,
    CustomMessageTimeZonePipe,
    ConfirmDialogComponent,
    DeleteModalComponent,
    GroupCallModalComponent,
    RatingAndReviewComponent,
    CommentMentionPipe,
    CommentsPipe,
    LikesPipe,
    NameLetterPipe,
    RepliesPipe,
    SafeHtmlPipe,
    SortByPipe,
    GroupCallScheduleComponent
  ],
  entryComponents: [ConfirmDialogComponent, DeleteModalComponent]
})
export class RolesSharedModule { }



// WEBPACK FOOTER //
// ./src/app/feature/main/roles-shared/roles-shared.module.ts